module.exports = __webpack_public_path__ + "img/house_3.f7780f67.jpg";